import { Link, useSearchParams } from "react-router-dom";
import { XCircle, RotateCcw } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";

export function PremiumCancel() {
  const [params] = useSearchParams();
  const guildId = params.get("guild_id") || "";
  const plan = params.get("plan") || "";
  const error = params.get("error") || "";

  return (
    <div className="max-w-lg mx-auto w-full space-y-6 py-10">
      <Card className="p-6 sm:p-8 text-center space-y-5 border-destructive/30">
        <div className="flex justify-center">
          <div className="h-16 w-16 rounded-full bg-destructive/20 flex items-center justify-center">
            <XCircle className="h-10 w-10 text-destructive" />
          </div>
        </div>

        <div className="space-y-2">
          <h1 className="text-2xl font-bold">Payment cancelled</h1>
          <p className="text-muted-foreground">
            We did not complete the charge. You were not billed.
          </p>
          {error ? (
            <p className="text-xs text-destructive font-mono">Reason: {error}</p>
          ) : null}
        </div>

        <div className="grid gap-2 pt-2">
          {guildId && plan ? (
            <Button asChild size="lg">
              <Link to={`/premium/${guildId}/checkout?plan=${plan}`}>
                <RotateCcw className="h-4 w-4" />
                Try again
              </Link>
            </Button>
          ) : null}
          <Button asChild variant="outline">
            <Link to="/dashboard">Back to dashboard</Link>
          </Button>
        </div>
      </Card>
    </div>
  );
}
